var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLoggedIn)?_c('connector-landing',{attrs:{"c":_vm.content}}):_c('connector-dashboard',{attrs:{"c":_vm.content,"uid":_vm.userId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }